<template>
    <!-- change -->
    <div class="inertia-tool">
        <div class="form__item">
            <label>
                <span>{{ $t('maxJerkTool.labelSpan') }}</span>
                <a class="label-text--second-line pull-right" @click="$emit('toggle')">
                    {{ $t('common.cancel') }}
                </a>
            </label>
        </div>
        <div class="inertia-tool__abstraction">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form__item">
                        <label>{{ $t('profiles.maxVdi') }}</label>
                        <div class="form__item">
                            <input
                                type="text"
                                :value="maxVolts"
                                @blur="updateMaxVolts"
                                class="form__input--text"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 form__item">
                <label>
                    <span>{{ $t('maxJerkTool.resulting') }}</span>
                </label>
                <input
                    type="text"
                    ref="localMaxJerk"
                    :value="localMaxJerk"
                    class="form__input--text"
                    disabled
                />
            </div>
            <div class="col-sm-6">
                <a class="button--secondary" style="margin-top: 3.2rem;" @click="useNewMaxJerk">
                    {{ $t('maxJerkTool.buttonUse') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {get} from '../helpers/UnitHelpers';

@Component
export default class MaxJerkTool extends Vue {
    @Prop() scenario;
    @Prop() profile;
    @Prop() maxVolts;
    @Prop() maxJerk;

    localMaxJerkValue = 0;

    created() {
        this.localMaxJerkValue = this.maxJerk !== 'undefined' ? this.maxJerk.scalar : null;
        this.convertMaxJerkVdi();
    }

    mounted() {
        this.convertMaxJerkVdi();
    }

    @Watch('maxVolts')
    newMaxVolts(newVal, oldVal) {
        let change = false;
        if (typeof oldVal === 'object') change = oldVal.scalar !== newVal.scalar;
        else change = oldVal !== newVal;

        if (change) this.convertMaxJerkVdi();
    }

    get maxVoltsValue() {
        return get(this.maxVolts);
    }

    get localMaxJerk() {
        return get(this.localMaxJerkValue) + ' m/s^3';
    }

    updateMaxVolts(ev) {
        this.$emit('updateMaxVolts', ev.target.value);
    }

    useNewMaxJerk(ev) {
        this.$emit('updateMaxJerk', this.localMaxJerk);
    }

    async convertMaxJerkVdi() {
        let body = {
            max_voltage: this.maxVolts ? this.maxVolts.scalar : null,
            motor_name: this.scenario.motor.name,
            moving_mass: this.scenario.applicationData._movingMass.scalar,
        };

        try {
            const res = await Vue.api.put('/convert-jerk-volts/').send(JSON.stringify(body));
            this.localMaxJerkValue = res.max_jerk;
            this.$emit('updateMaxVolts', res.max_voltage);
        } catch (err) {
            console.warn('[ save ] ERR', err);
        }
    }
}
</script>
